import { useConfigStore as config } from "@/stores/configStore";
import { useSsaStore as ssa } from "@/stores/ssaStore";
import { useActiveStore as active } from "@/stores/ssaStore/active";
const defaultPointConfig = {
	name: "colorby",
	label: "Color By",
	type: "component",
	component: "imdex-color-by-selector",
	isDiscrete: false,
	useGASAttributes: false,
	scaleType: "linear",
	layerType: "point",
	selectedProperty: null,
	colorMap: "Rainbow Uniform",
	categories: [
		{
			label: "Unknown",
			value: "unknown",
			color: "#ff0000",
			min: 0,
			max: 3,
			visible: true
		},
		{
			label: "Min",
			value: "min",
			color: "#FF5C00",
			min: 3,
			max: 6,
			visible: true
		},
		{
			label: "OREDS",
			value: "oreds",
			color: "#FFE600",
			min: 6,
			max: 9,
			visible: true
		},
		{
			label: "OREMS",
			value: "orems",
			color: "#ADFF00",
			min: 9,
			max: 12,
			visible: true
		},
		{
			label: "ORENMS",
			value: "orenms",
			color: "#05FF00",
			min: 12,
			max: 15,
			visible: true
		}
	],
	discreteColors: [
		{
			name: "Category 1",
			color: "#FF0000",
			min: 0,
			max: 10
		},
		{
			name: "Category 2",
			color: "#FF5C00",
			min: 0,
			max: 10
		},
		{
			name: "Category 3",
			color: "#FFE500",
			min: 0,
			max: 10
		},
		{
			name: "Category 4",
			color: "#ADFF00",
			min: 0,
			max: 10
		},
		{
			name: "Category 5",
			color: "#05FF00",
			min: 0,
			max: 10
		},
		{
			name: "Category 6",
			color: "#00F0FF",
			min: 0,
			max: 10
		},
		{
			name: "Category 7",
			color: "#0075FF",
			min: 0,
			max: 10
		},
		{
			name: "Category 8",
			color: "#2400FF",
			min: 0,
			max: 10
		}
	]
};
const defaultPickConfig = {
	name: "colorby",
	label: "Color By",
	type: "component",
	component: "imdex-color-by-selector",
	isDiscrete: true,
	useGASAttributes: false,
	layerType: "point",
	selectedProperty: null,
	categories: [
		{
			label: "Unknown",
			value: "unknown",
			color: "#ff0000",
			min: 0,
			max: 3,
			visible: true
		},
		{
			label: "Min",
			value: "min",
			color: "#FF5C00",
			min: 3,
			max: 6,
			visible: true
		},
		{
			label: "OREDS",
			value: "oreds",
			color: "#FFE600",
			min: 6,
			max: 9,
			visible: true
		},
		{
			label: "OREMS",
			value: "orems",
			color: "#ADFF00",
			min: 9,
			max: 12,
			visible: true
		},
		{
			label: "ORENMS",
			value: "orenms",
			color: "#05FF00",
			min: 12,
			max: 15,
			visible: true
		}
	]
};

export class DatasetConfigs {
	drillhole;
	blastdog_drillhole;
	blockmodel;
	surface;
	points;
	constructor() {
		this.blastdog_drillhole = [
			...Object.keys((config() as any).config.blastdog_defaults).map((defaultKey: any) => {
				const obj = (config() as any).config.blastdog_defaults[defaultKey];
				const defaultConfig: any = {
					name: defaultKey,
					selected: obj.selected || false,
					open: obj.open || false,
					visible: obj.visible || false,
					layerBlockName: "$label",
					layerName: "$layername",
					layerIdentifier: "$layer",
					fileName: "$filename",
					pointSize: obj.point_size || 3,
					lineWidth: obj.line_width || 3,
					color: obj.color,
					configuration: [
						{
							name: "showLabel",
							visible: false,
							label: "Show Label",
							type: "checkbox",
							pointSize: 8,
							value: false
						}
					]
				};
				if (obj.type) {
					defaultConfig.type = obj.type;
				}

				if (defaultKey == "Points") {
					defaultConfig.configuration = [
						{
							...defaultPointConfig,
							name: "colorby",
							label: "Color By",
							type: "component",
							component: "imdex-color-by-selector",
							colorMap: obj.color_scale || "Rainbow Uniform",
							isDiscrete: false,
							scaleType: obj.scale_type || "linear",
							layerType: "point"
						}
					];
				}
				if (
					defaultKey == "Drilled Collar" ||
					// defaultKey == "Drilled Survey" ||
					defaultKey == "Logged Collar"
					// defaultKey == "Logged Survey")
				) {
					defaultConfig.configuration = [
						{
							name: "colorby",
							label: "Color By",
							type: "component",
							component: "imdex-color-by-selector",
							layerType: "point",
							isDiscrete: false,
							scaleType: obj.scale_type || "linear",
							colorMap: obj.color_scale || "Rainbow Uniform"
						}
					];

					if (defaultKey !== "Points") {
						defaultConfig.configuration.push({
							name: "showLabel",
							visible: true,
							label: "Show Label",
							type: "checkbox",
							pointSize: 8,
							value: false,
							onChange: (v: boolean) => {
								// const displayPaneState = displayPane().DISPLAY_STATES;
								// const activeDatasetId = active().SSA_ACTIVE_DATASET.id;
								const activeView = active().view;
								// const selectedProperty = displayPaneState[activeView][activeDatasetId].find((item: any) => {
								// 	return item.selected && item.open;
								// }).configuration[0].selectedProperty;

								// if (selectedProperty) {
								// 	ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
								// 		layerName: active().SSA_ACTIVE_LAYER,
								// 		viewId: activeView,
								// 		type: "labels",
								// 		name: "CellFieldDataArrayName",
								// 		value: selectedProperty.value
								// 	});
								// }

								ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
									layerName: active().SSA_ACTIVE_LAYER,
									viewId: activeView,
									type: "labels",
									name: "Visibility",
									value: v ? 1 : 0
								});
							}
						});
					}
				}
				if (defaultConfig.type && defaultConfig.type == "picks") {
					defaultConfig.configuration = [defaultPickConfig];
				}

				return defaultConfig;
			}),
			{
				name: "picks",
				selected: false,
				visible: false,
				open: false,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						isDiscrete: true,
						scaleType: "linear",
						layerType: "point",
						selectedProperty: null,
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						]
					}
				]
			},
			{
				name: "survey",
				selected: false,
				visible: false,
				open: false
			}
		];
		this.drillhole = [
			{
				name: "collar",
				selected: (config() as any).config!.drillhole_defaults["Collar"].selected || true,
				open: (config() as any).config!.drillhole_defaults["Collar"].open || false,
				visible: false,
				pointSize: (config() as any).config!.drillhole_defaults["Collar"].point_size,
				color: (config() as any).config!.drillhole_defaults["Collar"].color,
				layerBlockName: "$label",
				layerName: "$layername",
				layerIdentifier: "$layer",
				fileName: "$filename",
				configuration: [
					// {
					// 	name: "showLabel",
					// 	label: "Show Label",
					// 	type: "checkbox",
					// 	pointSize:
					// 		(config() as any).config!.drillhole_defaults["Collar"].point_size || 8,
					// 	value: false,
					// 	visible: false,
					// 	onLoad: () => {
					// 		setTimeout(() => {
					// 			ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
					// 				layerName: active().SSA_ACTIVE_LAYER,
					// 				viewId: active().view,
					// 				type: "geometry",
					// 				name: "PointSize",
					// 				value: 8
					// 			});
					// 		}, 300);
					// 	},
					// 	onChange: (v: boolean) => {
					// 		const obj = {
					// 			layerName: active().SSA_ACTIVE_LAYER,
					// 			viewId: active().view,
					// 			type: "labels",
					// 			name: "MaximumNumberOfLabels",
					// 			value: 10000
					// 		};
					// 		ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
					// 			layerName: active().SSA_ACTIVE_LAYER,
					// 			viewId: active().view,
					// 			type: "labels",
					// 			name: "Visibility",
					// 			value: v ? 1 : 0
					// 		});
					// 		ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
					// 			layerName: active().SSA_ACTIVE_LAYER,
					// 			viewId: active().view,
					// 			type: "labels",
					// 			name: "PointLabelFontSize",
					// 			value: 26
					// 		});

					// 		ssa().SSA_REPRESENTATION_UPDATE_PROPERTY(obj);
					// 	}
					// },
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						// opacity: 100,
						// pointSize: 3, // now set inside colorBySelector based on value from Paraview (opacity as well). This causes them to appear empty initially, but the alternative is appearing as a potentially incorrect value initially
						isDiscrete: false,
						scaleType: "linear",
						layerType: "point",
						selectedProperty: null,
						colorMap: "Rainbow Uniform",
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						],
						discreteColors: [
							{
								name: "Category 1",
								color: "#FF0000",
								min: 0,
								max: 10
							},
							{
								name: "Category 2",
								color: "#FF5C00",
								min: 0,
								max: 10
							},
							{
								name: "Category 3",
								color: "#FFE500",
								min: 0,
								max: 10
							},
							{
								name: "Category 4",
								color: "#ADFF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 5",
								color: "#05FF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 6",
								color: "#00F0FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 7",
								color: "#0075FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 8",
								color: "#2400FF",
								min: 0,
								max: 10
							}
						]
					},
					{
						name: "showLabel",
						visible: true,
						label: "Show Label",
						type: "checkbox",
						pointSize: 8,
						value: false,
						onChange: (v: boolean) => {
							// const displayPaneState = displayPane().DISPLAY_STATES;
							// const activeDatasetId = active().SSA_ACTIVE_DATASET.id;
							const activeView = active().view;
							// const selectedProperty = displayPaneState[activeView][activeDatasetId].find((item: any) => {
							// 	return item.selected && item.open;
							// }).configuration[0].selectedProperty;

							// if (selectedProperty) {
							// 	ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
							// 		layerName: active().SSA_ACTIVE_LAYER,
							// 		viewId: activeView,
							// 		type: "labels",
							// 		name: "CellFieldDataArrayName",
							// 		value: selectedProperty.value
							// 	});
							// }

							ssa().SSA_REPRESENTATION_UPDATE_PROPERTY({
								layerName: active().SSA_ACTIVE_LAYER,
								viewId: activeView,
								type: "labels",
								name: "Visibility",
								value: v ? 1 : 0
							});
						}
					}
				]
			},
			{
				name: "survey",
				selected: (config() as any).config!.drillhole_defaults["Survey"].selected || false,
				color: (config() as any).config!.drillhole_defaults["Survey"].color,
				lineWidth: (config() as any).config!.drillhole_defaults["Survey"].line_width,
				visible: false,
				open: (config() as any).config!.drillhole_defaults["Survey"].open || false,
				configuration: [
					// {
					// 	name: "colorby",
					// 	label: "Color By",
					// 	type: "component",
					// 	component: "imdex-color-by-selector",
					// 	// opacity: 100,
					// 	// pointSize: 3, // now set inside colorBySelector based on value from Paraview (opacity as well). This causes them to appear empty initially, but the alternative is appearing as a potentially incorrect value initially
					// 	isDiscrete: false,
					// 	scaleType: "linear",
					// 	layerType: "point",
					// 	selectedProperty: null,
					// 	colorMap: "Rainbow Uniform",
					// 	categories: [
					// 		{
					// 			label: "Unknown",
					// 			value: "unknown",
					// 			color: "#ff0000",
					// 			min: 0,
					// 			max: 3,
					// 			visible: true
					// 		},
					// 		{
					// 			label: "Min",
					// 			value: "min",
					// 			color: "#FF5C00",
					// 			min: 3,
					// 			max: 6,
					// 			visible: true
					// 		},
					// 		{
					// 			label: "OREDS",
					// 			value: "oreds",
					// 			color: "#FFE600",
					// 			min: 6,
					// 			max: 9,
					// 			visible: true
					// 		},
					// 		{
					// 			label: "OREMS",
					// 			value: "orems",
					// 			color: "#ADFF00",
					// 			min: 9,
					// 			max: 12,
					// 			visible: true
					// 		},
					// 		{
					// 			label: "ORENMS",
					// 			value: "orenms",
					// 			color: "#05FF00",
					// 			min: 12,
					// 			max: 15,
					// 			visible: true
					// 		}
					// 	],
					// 	discreteColors: [
					// 		{
					// 			name: "Category 1",
					// 			color: "#FF0000",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 2",
					// 			color: "#FF5C00",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 3",
					// 			color: "#FFE500",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 4",
					// 			color: "#ADFF00",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 5",
					// 			color: "#05FF00",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 6",
					// 			color: "#00F0FF",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 7",
					// 			color: "#0075FF",
					// 			min: 0,
					// 			max: 10
					// 		},
					// 		{
					// 			name: "Category 8",
					// 			color: "#2400FF",
					// 			min: 0,
					// 			max: 10
					// 		}
					// 	]
					// }
				]
			},
			// {
			// 	name: "Actual Survey",
			// 	selected: false,
			// 	visible: false,
			// 	open: false
			// },
			// {
			// 	name: "Planned Survey",
			// 	selected: false,
			// 	visible: false,
			// 	open: false
			// },
			{
				name: "points",
				selected: (config() as any).config!.drillhole_defaults["Points"].selected || true,
				visible: false,
				open: (config() as any).config!.drillhole_defaults["Points"].open || true,
				pointSize: (config() as any).config!.drillhole_defaults["Points"].point_size,
				color: (config() as any).config!.drillhole_defaults["Points"].color,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						// opacity: 100,
						// pointSize: 3, // now set inside colorBySelector based on value from Paraview (opacity as well). This causes them to appear empty initially, but the alternative is appearing as a potentially incorrect value initially
						isDiscrete: false,
						scaleType: "linear",
						layerType: "point",
						selectedProperty: null,
						colorMap: "Rainbow Uniform",
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						],
						discreteColors: [
							{
								name: "Category 1",
								color: "#FF0000",
								min: 0,
								max: 10
							},
							{
								name: "Category 2",
								color: "#FF5C00",
								min: 0,
								max: 10
							},
							{
								name: "Category 3",
								color: "#FFE500",
								min: 0,
								max: 10
							},
							{
								name: "Category 4",
								color: "#ADFF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 5",
								color: "#05FF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 6",
								color: "#00F0FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 7",
								color: "#0075FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 8",
								color: "#2400FF",
								min: 0,
								max: 10
							}
						]
					}
				]
			},
			{
				name: "intervals",
				selected:
					(config() as any).config!.drillhole_defaults["Intervals"].selected || false,
				visible: false,
				open: (config() as any).config!.drillhole_defaults["Intervals"].open || false,
				pointSize: (config() as any).config!.drillhole_defaults["Intervals"].point_size,
				color: (config() as any).config!.drillhole_defaults["Intervals"].color,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						layerType: "interval",
						cellOutline: false,
						isDiscrete: false,
						scaleType: "linear",
						selectedProperty: null,
						colorMap: "Rainbow Uniform",
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						],
						discreteColors: [
							{
								name: "Category 1",
								color: "#FF0000",
								min: 0,
								max: 10
							},
							{
								name: "Category 2",
								color: "#FF5C00",
								min: 0,
								max: 10
							},
							{
								name: "Category 3",
								color: "#FFE500",
								min: 0,
								max: 10
							},
							{
								name: "Category 4",
								color: "#ADFF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 5",
								color: "#05FF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 6",
								color: "#00F0FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 7",
								color: "#0075FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 8",
								color: "#2400FF",
								min: 0,
								max: 10
							}
						]
					}
				]
			},
			{
				name: "picks",
				selected: false,
				visible: false,
				open: false,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						isDiscrete: true,
						layerType: "point",
						selectedProperty: null,
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						]
					}
				]
			}
			// {
			// 	name: "picks",
			// 	selected: false,
			// 	visible: false,
			// 	open: false,
			// 	configuration: [
			// 		{
			// 			name: "water_level",
			// 			label: "Water Level",
			// 			type: "checkbox",
			// 			value: false
			// 		},
			// 		{
			// 			name: "coal_seam",
			// 			label: "Coal Seam",
			// 			type: "checkbox",
			// 			value: false
			// 		},
			// 		{
			// 			name: "other",
			// 			label: "Other",
			// 			type: "checkbox",
			// 			value: false
			// 		}
			// 	]
			// }
		];
		this.blockmodel = [
			{
				name: "Blocks",
				selected: true,
				open: true,
				visible: false,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						cellOutline: false,
						isDiscrete: false,
						scaleType: "linear",

						selectedProperty: null,
						colorMap: "Rainbow Uniform",
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						],
						discreteColors: [
							{
								name: "Category 1",
								color: "#FF0000",
								min: 0,
								max: 10
							},
							{
								name: "Category 2",
								color: "#FF5C00",
								min: 0,
								max: 10
							},
							{
								name: "Category 3",
								color: "#FFE500",
								min: 0,
								max: 10
							},
							{
								name: "Category 4",
								color: "#ADFF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 5",
								color: "#05FF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 6",
								color: "#00F0FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 7",
								color: "#0075FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 8",
								color: "#2400FF",
								min: 0,
								max: 10
							}
						]
					}
				]
			},
			{
				name: "Slicing",
				selected: false,
				open: false,
				visible: true,
				disabled: false,
				layerBlockName: "$label",
				layerName: "$layername",
				layerIdentifier: "$layer",
				fileName: "$filename",
				configuration: [
					{
						name: "slicing",
						label: "Slicing",
						type: "component",
						component: "imdex-slicing"
					}
				]
			}
		];
		this.surface = [
			{
				name: "Surface",
				selected: true,
				open: true,
				visible: true,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						cellOutline: false,
						isDiscrete: false,
						scaleType: "linear",
						selectedProperty: null,
						colorMap: "Rainbow Uniform",
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						],
						discreteColors: [
							{
								name: "Category 1",
								color: "#FF0000",
								min: 0,
								max: 10
							},
							{
								name: "Category 2",
								color: "#FF5C00",
								min: 0,
								max: 10
							},
							{
								name: "Category 3",
								color: "#FFE500",
								min: 0,
								max: 10
							},
							{
								name: "Category 4",
								color: "#ADFF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 5",
								color: "#05FF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 6",
								color: "#00F0FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 7",
								color: "#0075FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 8",
								color: "#2400FF",
								min: 0,
								max: 10
							}
						]
					}
				]
			}
		];
		this.points = [
			{
				name: "Points",
				selected: true,
				open: true,
				visible: true,
				configuration: [
					{
						name: "colorby",
						label: "Color By",
						type: "component",
						component: "imdex-color-by-selector",
						cellOutline: false,
						isDiscrete: false,
						useGASAttributes: false,
						scaleType: "linear",

						selectedProperty: null,
						colorMap: "Rainbow Uniform",
						categories: [
							{
								label: "Unknown",
								value: "unknown",
								color: "#ff0000",
								min: 0,
								max: 3,
								visible: true
							},
							{
								label: "Min",
								value: "min",
								color: "#FF5C00",
								min: 3,
								max: 6,
								visible: true
							},
							{
								label: "OREDS",
								value: "oreds",
								color: "#FFE600",
								min: 6,
								max: 9,
								visible: true
							},
							{
								label: "OREMS",
								value: "orems",
								color: "#ADFF00",
								min: 9,
								max: 12,
								visible: true
							},
							{
								label: "ORENMS",
								value: "orenms",
								color: "#05FF00",
								min: 12,
								max: 15,
								visible: true
							}
						],
						discreteColors: [
							{
								name: "Category 1",
								color: "#FF0000",
								min: 0,
								max: 10
							},
							{
								name: "Category 2",
								color: "#FF5C00",
								min: 0,
								max: 10
							},
							{
								name: "Category 3",
								color: "#FFE500",
								min: 0,
								max: 10
							},
							{
								name: "Category 4",
								color: "#ADFF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 5",
								color: "#05FF00",
								min: 0,
								max: 10
							},
							{
								name: "Category 6",
								color: "#00F0FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 7",
								color: "#0075FF",
								min: 0,
								max: 10
							},
							{
								name: "Category 8",
								color: "#2400FF",
								min: 0,
								max: 10
							}
						]
					}
				]
			}
		];
	}
}
